import { useQuery } from 'components/hooks/useQuery';

export const useCalibrationViewLandingQueryParams = () => {
  const queryParams = useQuery();
  const { calibrationViewId } = queryParams;
  return { calibrationViewId };
};
